import api from "../../axiosconfig";

export async function getAudioConfig() {
  const { data } = await api.get("/api/audio/config");
  return data;
}
